export const NAVIGATION_TYPE = { internal: 'planogram', external: 'url', back: 'back' };
